/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachPaperclipIcon24Regular = forwardRef('AttachPaperclipIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.677 4.88a4.271 4.271 0 1 1 6.041 6.04l-8.373 8.373a6.032 6.032 0 0 1-8.53-8.531l5.857-5.858a.75.75 0 1 1 1.061 1.06l-5.858 5.859a4.532 4.532 0 1 0 6.41 6.409l8.372-8.373a2.771 2.771 0 1 0-3.919-3.92L7.378 14.3a1.01 1.01 0 1 0 1.43 1.43l5.844-5.846a.75.75 0 0 1 1.061 1.06L9.868 16.79a2.51 2.51 0 1 1-3.55-3.55l8.36-8.36Z" })));
});
